import { keyframes } from "styled-components"

export const trainApearAnim = keyframes`
    0% {
      opacity: 0;
      width: 0;
    }
    100% {
      opacity: 1;
      width: 53px;
    }
`
export const trainRemoveAnim = keyframes`
    0% {
      width: 53px;
      margin-right: 2px;
      opacity: 1;
    }
    100% {
      width: 0;
      opacity: 0;
      margin-right: 0px;
    }
`
export const fadeOutAnim = keyframes`
0% {   opacity: 1; }
 50% {  opacity: 0; }
 100% {  opacity: 1; }
`
